import { handleUnitedKingdomException } from '@/components/ui/design-system/lib/countries';
import libphonenumberParser, { type CountryCode, type PhoneNumber } from 'libphonenumber-js';

export { handleUnitedKingdomException };

const letters: Record<string, string> = {
  A: '🇦',
  B: '🇧',
  C: '🇨',
  D: '🇩',
  E: '🇪',
  F: '🇫',
  G: '🇬',
  H: '🇭',
  I: '🇮',
  J: '🇯',
  K: '🇰',
  L: '🇱',
  M: '🇲',
  N: '🇳',
  O: '🇴',
  P: '🇵',
  Q: '🇶',
  R: '🇷',
  S: '🇸',
  T: '🇹',
  U: '🇺',
  V: '🇻',
  W: '🇼',
  X: '🇽',
  Y: '🇾',
  Z: '🇿',
};

interface CountryData {
  code: CountryCode;
  num: string;
  country: string;
}

export const countries: Record<CountryCode, CountryData> = {
  US: { code: 'US', num: '+1', country: 'United States' },
  AF: { code: 'AF', num: '+93', country: 'Afghanistan' },
  AL: { code: 'AL', num: '+355', country: 'Albania' },
  DZ: { code: 'DZ', num: '+213', country: 'Algeria' },
  AS: { code: 'AS', num: '+1', country: 'American Samoa' },
  AD: { code: 'AD', num: '+376', country: 'Andorra' },
  AO: { code: 'AO', num: '+244', country: 'Angola' },
  AI: { code: 'AI', num: '+1', country: 'Anguilla' },
  AG: { code: 'AG', num: '+1-268', country: 'Antigua and Barbuda' },
  AR: { code: 'AR', num: '+54', country: 'Argentina' },
  AM: { code: 'AM', num: '+374', country: 'Armenia' },
  AW: { code: 'AW', num: '+297', country: 'Aruba' },
  AU: { code: 'AU', num: '+61', country: 'Australia' },
  AT: { code: 'AT', num: '+43', country: 'Austria' },
  AZ: { code: 'AZ', num: '+994', country: 'Azerbaijan' },
  BH: { code: 'BH', num: '+973', country: 'Bahrain' },
  BD: { code: 'BD', num: '+880', country: 'Bangladesh' },
  BB: { code: 'BB', num: '+1-246', country: 'Barbados' },
  BY: { code: 'BY', num: '+375', country: 'Belarus' },
  BE: { code: 'BE', num: '+32', country: 'Belgium' },
  BZ: { code: 'BZ', num: '+501', country: 'Belize' },
  BJ: { code: 'BJ', num: '+229', country: 'Benin' },
  BM: { code: 'BM', num: '+1', country: 'Bermuda' },
  BT: { code: 'BT', num: '+975', country: 'Bhutan' },
  BO: { code: 'BO', num: '+591', country: 'Bolivia' },
  BA: { code: 'BA', num: '+387', country: 'Bosnia and Herzegovina' },
  BW: { code: 'BW', num: '+267', country: 'Botswana' },
  BR: { code: 'BR', num: '+55', country: 'Brazil' },
  IO: { code: 'IO', num: '+246', country: 'British Indian Ocean Territory' },
  BN: { code: 'BN', num: '+673', country: 'Brunei' },
  BG: { code: 'BG', num: '+359', country: 'Bulgaria' },
  BF: { code: 'BF', num: '+226', country: 'Burkina Faso' },
  BI: { code: 'BI', num: '+257', country: 'Burundi' },
  KH: { code: 'KH', num: '+855', country: 'Cambodia' },
  CM: { code: 'CM', num: '+237', country: 'Cameroon' },
  CA: { code: 'CA', num: '+1', country: 'Canada' },
  CV: { code: 'CV', num: '+238', country: 'Cape Verde' },
  KY: { code: 'KY', num: '+1', country: 'Cayman Islands' },
  CF: { code: 'CF', num: '+236', country: 'Central African Republic' },
  TD: { code: 'TD', num: '+235', country: 'Chad' },
  CL: { code: 'CL', num: '+56', country: 'Chile' },
  CN: { code: 'CN', num: '+86', country: 'China' },
  CX: { code: 'CX', num: '+61', country: 'Christmas Island' },
  CC: { code: 'CC', num: '+61', country: 'Cocos (Keeling) Islands' },
  CO: { code: 'CO', num: '+57', country: 'Colombia' },
  KM: { code: 'KM', num: '+269', country: 'Comoros' },
  CG: { code: 'CG', num: '+242', country: 'Congo, Republic of the (Congo - Brazzaville)' },
  CK: { code: 'CK', num: '+682', country: 'Cook Islands' },
  CR: { code: 'CR', num: '+506', country: 'Costa Rica' },
  CI: { code: 'CI', num: '+225', country: "Cote d'Ivoire (Ivory Coast)" },
  HR: { code: 'HR', num: '+385', country: 'Croatia' },
  CU: { code: 'CU', num: '+53', country: 'Cuba' },
  CY: { code: 'CY', num: '+357', country: 'Cyprus' },
  CZ: { code: 'CZ', num: '+420', country: 'Czech Republic' },
  DK: { code: 'DK', num: '+45', country: 'Denmark' },
  DJ: { code: 'DJ', num: '+253', country: 'Djibouti' },
  DM: { code: 'DM', num: '+1-767', country: 'Dominica' },
  DO: { code: 'DO', num: '+1', country: 'Dominican Republic' },
  EC: { code: 'EC', num: '+593', country: 'Ecuador' },
  EG: { code: 'EG', num: '+20', country: 'Egypt' },
  SV: { code: 'SV', num: '+503', country: 'El Salvador' },
  GQ: { code: 'GQ', num: '+240', country: 'Equatorial Guinea' },
  ER: { code: 'ER', num: '+291', country: 'Eritrea' },
  EE: { code: 'EE', num: '+372', country: 'Estonia' },
  ET: { code: 'ET', num: '+251', country: 'Ethiopia' },
  FK: { code: 'FK', num: '+500', country: 'Falkland Islands' },
  FO: { code: 'FO', num: '+298', country: 'Faroe Islands' },
  FJ: { code: 'FJ', num: '+679', country: 'Fiji' },
  FI: { code: 'FI', num: '+358', country: 'Finland' },
  FR: { code: 'FR', num: '+33', country: 'France' },
  GF: { code: 'GF', num: '+594', country: 'French Guiana' },
  PF: { code: 'PF', num: '+689', country: 'French Polynesia' },
  GA: { code: 'GA', num: '+241', country: 'Gabon' },
  GE: { code: 'GE', num: '+995', country: 'Georgia' },
  DE: { code: 'DE', num: '+49', country: 'Germany' },
  GH: { code: 'GH', num: '+233', country: 'Ghana' },
  GI: { code: 'GI', num: '+350', country: 'Gibraltar' },
  GR: { code: 'GR', num: '+30', country: 'Greece' },
  GL: { code: 'GL', num: '+299', country: 'Greenland' },
  GD: { code: 'GD', num: '+1-473', country: 'Grenada' },
  GP: { code: 'GP', num: '+590', country: 'Guadeloupe' },
  GU: { code: 'GU', num: '+1', country: 'Guam' },
  GT: { code: 'GT', num: '+502', country: 'Guatemala' },
  GG: { code: 'GG', num: '+44', country: 'Guernsey and Alderney' },
  GN: { code: 'GN', num: '+224', country: 'Guinea' },
  GW: { code: 'GW', num: '+245', country: 'Guinea-Bissau' },
  GY: { code: 'GY', num: '+592', country: 'Guyana' },
  HT: { code: 'HT', num: '+509', country: 'Haiti' },
  HN: { code: 'HN', num: '+504', country: 'Honduras' },
  HK: { code: 'HK', num: '+852', country: 'Hong Kong' },
  HU: { code: 'HU', num: '+36', country: 'Hungary' },
  IS: { code: 'IS', num: '+354', country: 'Iceland' },
  IN: { code: 'IN', num: '+91', country: 'India' },
  ID: { code: 'ID', num: '+62', country: 'Indonesia' },
  IR: { code: 'IR', num: '+98', country: 'Iran' },
  IQ: { code: 'IQ', num: '+964', country: 'Iraq' },
  IE: { code: 'IE', num: '+353', country: 'Ireland' },
  IM: { code: 'IM', num: '+44', country: 'Isle of Man' },
  IL: { code: 'IL', num: '+972', country: 'Israel' },
  IT: { code: 'IT', num: '+39', country: 'Italy' },
  JM: { code: 'JM', num: '+1-876', country: 'Jamaica' },
  JP: { code: 'JP', num: '+81', country: 'Japan' },
  JE: { code: 'JE', num: '+44', country: 'Jersey' },
  JO: { code: 'JO', num: '+962', country: 'Jordan' },
  KZ: { code: 'KZ', num: '+7', country: 'Kazakhstan' },
  KE: { code: 'KE', num: '+254', country: 'Kenya' },
  KI: { code: 'KI', num: '+686', country: 'Kiribati' },
  KW: { code: 'KW', num: '+965', country: 'Kuwait' },
  KG: { code: 'KG', num: '+996', country: 'Kyrgyzstan' },
  AX: { code: 'AX', num: '+358', country: 'Aland Islands' },
  LA: { code: 'LA', num: '+856', country: 'Laos' },
  LV: { code: 'LV', num: '+371', country: 'Latvia' },
  LB: { code: 'LB', num: '+961', country: 'Lebanon' },
  LS: { code: 'LS', num: '+266', country: 'Lesotho' },
  LR: { code: 'LR', num: '+231', country: 'Liberia' },
  LY: { code: 'LY', num: '+218', country: 'Libya' },
  LI: { code: 'LI', num: '+423', country: 'Liechtenstein' },
  LT: { code: 'LT', num: '+370', country: 'Lithuania' },
  LU: { code: 'LU', num: '+352', country: 'Luxembourg' },
  MO: { code: 'MO', num: '+853', country: 'Macao' },
  MK: { code: 'MK', num: '+389', country: 'Macedonia' },
  MG: { code: 'MG', num: '+261', country: 'Madagascar' },
  MW: { code: 'MW', num: '+265', country: 'Malawi' },
  MY: { code: 'MY', num: '+60', country: 'Malaysia' },
  MV: { code: 'MV', num: '+960', country: 'Maldives' },
  ML: { code: 'ML', num: '+223', country: 'Mali' },
  MT: { code: 'MT', num: '+356', country: 'Malta' },
  MH: { code: 'MH', num: '+692', country: 'Marshall Islands' },
  MQ: { code: 'MQ', num: '+596', country: 'Martinique' },
  MR: { code: 'MR', num: '+222', country: 'Mauritania' },
  MU: { code: 'MU', num: '+230', country: 'Mauritius' },
  YT: { code: 'YT', num: '+269', country: 'Mayotte' },
  MX: { code: 'MX', num: '+52', country: 'Mexico' },
  FM: { code: 'FM', num: '+691', country: 'Micronesia' },
  MD: { code: 'MD', num: '+373', country: 'Moldova' },
  MC: { code: 'MC', num: '+377', country: 'Monaco' },
  MN: { code: 'MN', num: '+976', country: 'Mongolia' },
  ME: { code: 'ME', num: '+382', country: 'Montenegro' },
  MS: { code: 'MS', num: '+1', country: 'Montserrat' },
  MA: { code: 'MA', num: '+212', country: 'Morocco' },
  MZ: { code: 'MZ', num: '+258', country: 'Mozambique' },
  MM: { code: 'MM', num: '+95', country: 'Myanmar (Burma)' },
  NA: { code: 'NA', num: '+264', country: 'Namibia' },
  NR: { code: 'NR', num: '+674', country: 'Nauru' },
  NP: { code: 'NP', num: '+977', country: 'Nepal' },
  NL: { code: 'NL', num: '+31', country: 'Netherlands' },
  NC: { code: 'NC', num: '+687', country: 'New Caledonia' },
  NZ: { code: 'NZ', num: '+64', country: 'New Zealand' },
  NI: { code: 'NI', num: '+505', country: 'Nicaragua' },
  NE: { code: 'NE', num: '+227', country: 'Niger' },
  NG: { code: 'NG', num: '+234', country: 'Nigeria' },
  NU: { code: 'NU', num: '+683', country: 'Niue' },
  NF: { code: 'NF', num: '+672', country: 'Norfolk Island' },
  MP: { code: 'MP', num: '+1', country: 'Northern Mariana Islands' },
  KP: { code: 'KP', num: '+850', country: "Korea, Democratic People's Republic of (North Korea)" },
  NO: { code: 'NO', num: '+47', country: 'Norway' },
  OM: { code: 'OM', num: '+968', country: 'Oman' },
  PK: { code: 'PK', num: '+92', country: 'Pakistan' },
  PW: { code: 'PW', num: '+680', country: 'Palau' },
  PS: { code: 'PS', num: '+970', country: 'Palestine' },
  PA: { code: 'PA', num: '+507', country: 'Panama' },
  PG: { code: 'PG', num: '+675', country: 'Papua New Guinea' },
  PY: { code: 'PY', num: '+595', country: 'Paraguay' },
  PE: { code: 'PE', num: '+51', country: 'Peru' },
  PH: { code: 'PH', num: '+63', country: 'Philippines' },
  PL: { code: 'PL', num: '+48', country: 'Poland' },
  PT: { code: 'PT', num: '+351', country: 'Portugal' },
  PR: { code: 'PR', num: '+1', country: 'Puerto Rico' },
  QA: { code: 'QA', num: '+974', country: 'Qatar' },
  RO: { code: 'RO', num: '+40', country: 'Romania' },
  RE: { code: 'RE', num: '+262', country: 'Reunion' },
  RU: { code: 'RU', num: '+7', country: 'Russia' },
  RW: { code: 'RW', num: '+250', country: 'Rwanda' },
  BL: { code: 'BL', num: '+590', country: 'Saint Barthelemy' },
  SH: { code: 'SH', num: '+290', country: 'Saint Helena' },
  KN: { code: 'KN', num: '+1-869', country: 'Saint Kitts and Nevis' },
  LC: { code: 'LC', num: '+1-758', country: 'Saint Lucia' },
  MF: { code: 'MF', num: '+590', country: 'Saint Martin' },
  PM: { code: 'PM', num: '+508', country: 'Saint Pierre and Miquelon' },
  VC: { code: 'VC', num: '+1-784', country: 'Saint Vincent and the Grenadines' },
  WS: { code: 'WS', num: '+685', country: 'Samoa' },
  SM: { code: 'SM', num: '+378', country: 'San Marino' },
  ST: { code: 'ST', num: '+239', country: 'Sao Tome and Principe' },
  SA: { code: 'SA', num: '+966', country: 'Saudi Arabia' },
  SN: { code: 'SN', num: '+221', country: 'Senegal' },
  RS: { code: 'RS', num: '+381', country: 'Serbia' },
  SC: { code: 'SC', num: '+248', country: 'Seychelles' },
  SL: { code: 'SL', num: '+232', country: 'Sierra Leone' },
  SG: { code: 'SG', num: '+65', country: 'Singapore' },
  SK: { code: 'SK', num: '+421', country: 'Slovakia' },
  SI: { code: 'SI', num: '+386', country: 'Slovenia' },
  SB: { code: 'SB', num: '+677', country: 'Solomon Islands' },
  SO: { code: 'SO', num: '+252', country: 'Somalia' },
  ZA: { code: 'ZA', num: '+27', country: 'South Africa' },
  KR: { code: 'KR', num: '+82', country: 'Korea, Republic of (South Korea)' },
  ES: { code: 'ES', num: '+34', country: 'Spain' },
  LK: { code: 'LK', num: '+94', country: 'Sri Lanka' },
  SD: { code: 'SD', num: '+249', country: 'Sudan' },
  SR: { code: 'SR', num: '+597', country: 'Suriname' },
  SJ: { code: 'SJ', num: '+47', country: 'Svalbard and Jan Mayen' },
  SZ: { code: 'SZ', num: '+268', country: 'Swaziland' },
  SE: { code: 'SE', num: '+46', country: 'Sweden' },
  CH: { code: 'CH', num: '+41', country: 'Switzerland' },
  SY: { code: 'SY', num: '+963', country: 'Syria' },
  TW: { code: 'TW', num: '+886', country: 'Taiwan (ROC)' },
  TJ: { code: 'TJ', num: '+992', country: 'Tajikistan' },
  TZ: { code: 'TZ', num: '+255', country: 'Tanzania' },
  TH: { code: 'TH', num: '+66', country: 'Thailand' },
  BS: { code: 'BS', num: '+1-242', country: 'Bahamas, The' },
  GM: { code: 'GM', num: '+220', country: 'Gambia, The' },
  TL: { code: 'TL', num: '+670', country: 'Timor-Leste (East Timor)' },
  TG: { code: 'TG', num: '+228', country: 'Togo' },
  TK: { code: 'TK', num: '+690', country: 'Tokelau' },
  TO: { code: 'TO', num: '+676', country: 'Tonga' },
  TT: { code: 'TT', num: '+1-868', country: 'Trinidad and Tobago' },
  TN: { code: 'TN', num: '+216', country: 'Tunisia' },
  TR: { code: 'TR', num: '+90', country: 'Turkey' },
  TM: { code: 'TM', num: '+993', country: 'Turkmenistan' },
  TC: { code: 'TC', num: '+1', country: 'Turks and Caicos Islands' },
  TV: { code: 'TV', num: '+688', country: 'Tuvalu' },
  UG: { code: 'UG', num: '+256', country: 'Uganda' },
  UA: { code: 'UA', num: '+380', country: 'Ukraine' },
  AE: { code: 'AE', num: '+971', country: 'United Arab Emirates' },
  GB: { code: 'GB', num: '+44', country: 'United Kingdom' },
  UY: { code: 'UY', num: '+598', country: 'Uruguay' },
  UZ: { code: 'UZ', num: '+998', country: 'Uzbekistan' },
  VU: { code: 'VU', num: '+678', country: 'Vanuatu' },
  VA: { code: 'VA', num: '+379', country: 'Vatican City' },
  VE: { code: 'VE', num: '+58', country: 'Venezuela' },
  VN: { code: 'VN', num: '+84', country: 'Vietnam' },
  VG: { code: 'VG', num: '+1', country: 'British Virgin Islands' },
  VI: { code: 'VI', num: '+1', country: 'Virgin Islands of the United States' },
  WF: { code: 'WF', num: '+681', country: 'Wallis and Futuna' },
  EH: { code: 'EH', num: '+212', country: 'Western Sahara' },
  YE: { code: 'YE', num: '+967', country: 'Yemen' },
  ZM: { code: 'ZM', num: '+260', country: 'Zambia' },
  ZW: { code: 'ZW', num: '+263', country: 'Zimbabwe' },
  AC: { code: 'AC', num: '+247', country: 'Ascension Island' },
  BQ: { code: 'BQ', num: '+599', country: 'Bonaire, Sint Eustatius and Saba' },
  CD: { code: 'CD', num: '+243', country: 'Congo, Democratic Republic of the (DRC)' },
  CW: { code: 'CW', num: '+599', country: 'Curaçao' },
  SS: { code: 'SS', num: '+211', country: 'South Sudan' },
  SX: { code: 'SX', num: '+599', country: 'Sint Maarten' },
  TA: { code: 'TA', num: '+290', country: 'Tristan da Cunha' },
  XK: { code: 'XK', num: '+383', country: 'Kosovo' },
};

// Narrow an arbitrary string from the API (e.g. `order.country`) into a
// CountryCode. Returns undefined if the value isn't a known ISO key — pair
// with a fallback (`?? 'FR'`) at the callsite rather than blind-casting.
export const toCountryCode = (value: string | null | undefined): CountryCode | undefined => {
  if (!value) {
    return undefined;
  }
  return value in countries ? (value as CountryCode) : undefined;
};

export const getCountryByLanguage = (language: string) => {
  const country = countries[language.slice(0, 2).toUpperCase() as CountryCode];

  return country ?? countries.US;
};

export const getCountryFlag = (country: CountryData) => {
  return (
    (letters[country.code.substring(0, 1)] ?? '') + (letters[country.code.substring(1, 2)] ?? '')
  );
};
export const getCountryInfos = (countryKey: CountryCode | 'UK') => {
  const country = countries[handleUnitedKingdomException(countryKey)];
  return {
    flag: getCountryFlag(country),
    ...country,
  };
};

export const parsePhoneNumber = (phoneNumber: string, defaultCountry?: CountryCode) => {
  return libphonenumberParser(phoneNumber, defaultCountry);
};

export const getCountryByNumber = (number: PhoneNumber) => {
  return number.country && countries[number.country];
};
